<template>
  <view-container>
    <v-alert
      type="warning"
      dense
      dismissible
      :icon="false"
      v-model="isClientExist"
    >
      <v-row align="center" dense>
        <v-col class="grow"
          >Касса для клиента с таким ИНН уже заведена в систему</v-col
        >
      </v-row>
    </v-alert>
    <v-stepper v-model="step" class="elevation-0">
      <v-stepper-header class="elevation-0">
        <v-stepper-step :complete="step > 1" step="1" editable
          >Устройство</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2"
          >Информация о клиенте</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3"
          >Реквизиты доступа</v-stepper-step
        >
      </v-stepper-header>
      <v-stepper-items>
        <view-container>
          <v-row>
            <v-col cols="12">
              <v-card>
                <v-stepper-content step="1">
                  <view-container>
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-card-text>
                          <div class="font-weight-bold">Тип устройства</div>
                          <v-radio-group v-model="config.device">
                            <v-radio
                              v-for="type in deviceTypes"
                              :key="type.id"
                              :label="type.name"
                              :value="type.value"
                            >
                            </v-radio>
                          </v-radio-group>
                        </v-card-text>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card-text v-if="config.device == 'ams'">
                          <div class="font-weight-bold">Конфигурация</div>
                          <v-text-field
                            v-model="config.ip"
                            class="mt-4"
                            :error-messages="wrongIpMessage"
                            label="IP-адрес"
                            placeholder="0.0.0.0"
                          >
                          </v-text-field>
                          <v-checkbox
                            v-model="config.nonDefaultAccess"
                            class="mt-0"
                            hide-details
                            label="параметры доступа к кассе"
                          ></v-checkbox>
                          <div v-if="config.nonDefaultAccess">
                            <v-text-field
                              v-model="config.devicePass"
                              dense
                              hide-details
                              class="mt-0"
                              label="пароль соединения"
                              type="password"
                            >
                            </v-text-field>
                            <v-text-field
                              v-model="config.login"
                              class="mt-0"
                              dense
                              hide-details
                              label="логин"
                            >
                            </v-text-field>
                            <v-text-field
                              v-model="config.password"
                              class="mt-0"
                              dense
                              hide-details
                              label="пароль"
                              type="password"
                            >
                            </v-text-field>
                            <v-text-field
                              v-model="config.port"
                              class="mt-0"
                              dense
                              hide-details
                              label="порт"
                            >
                            </v-text-field>
                          </div>
                          <v-checkbox
                            v-model="config.addTestDevice"
                            class="mt-4"
                            hide-details
                            label="cоздать дополнительно тестовый доступ"
                          ></v-checkbox>
                        </v-card-text>
                      </v-col>
                      <v-col cols="12">
                        <v-card-actions>
                          <v-btn @click="getInfo" :disabled="!validate(1)"
                            >Продолжить</v-btn
                          >
                          <v-btn text @click="cancel()">Отмена</v-btn>
                        </v-card-actions>
                      </v-col>
                    </v-row>
                  </view-container>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <view-container>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            v-model="data.name"
                            class="mt-0"
                            dense
                            disabled
                            label="Наименование компании"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0">
                          <v-text-field
                            v-model="data.inn"
                            class="mt-0"
                            disabled
                            dense
                            label="ИНН"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" class="pb-0 pt-0">
                          <v-text-field
                            v-model="data.desc"
                            class="mt-0"
                            dense
                            label="Описание"
                            placeholder="местоположение, род деятельности"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pb-0 pt-0">
                          <v-select
                            v-model="data.taxSystem"
                            class="mt-0"
                            dense
                            :items="taxSystems"
                            item-text="name"
                            item-value="id"
                            label="Система налогообложения"
                          />
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0">
                          <v-text-field
                            v-model="data.timezone"
                            class="mt-0"
                            disabled
                            dense
                            label="Часовой пояс"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0">
                          <v-text-field
                            v-model="data.login"
                            class="mt-0"
                            dense
                            :error-messages="wrongLoginMessage"
                            label="Логин для доступа в ЛК"
                            placeholder="login@login.ru"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" class="pt-0">
                          <v-text-field
                            v-model="data.maxCashiers"
                            class="mt-0"
                            dense
                            label="Количество кассиров (аккаунтов)"
                            placeholder="0"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-row>
                        <v-col cols="12">
                          <v-btn @click="createComplex" :disabled="!validate(2)"
                            >Создать
                          </v-btn>
                          <v-btn text @click="cancel()">Отмена</v-btn>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </view-container>
                </v-stepper-content>
                <v-stepper-content step="3">
                  <view-container>
                    <v-row>
                      <v-col cols="12">
                        <v-card-text class="pb-0">
                          Реквизиты доступа в личный кабинет для нового клиента:
                        </v-card-text>
                        <v-card-text>
                          Логин: {{ data.login }}<br />
                          Пароль: {{ result.password }}
                        </v-card-text>
                        <v-card-text class="pb-0">
                          Реквизиты доступа к кассе по API:
                        </v-card-text>
                        <v-card-text>
                          ID группы касс: {{ result.group }}<br />
                          Ключ доступа к группе касс: {{ result.key }}
                        </v-card-text>
                        <v-card-text class="font-weight-bold">
                          Внимание! Не покидайте эту страницу до тех пор, пока
                          не передадите параметры доступа клиенту!
                        </v-card-text>
                        <v-card-actions class="mt-4">
                          <v-btn @click="cancel()">Завершить</v-btn>
                        </v-card-actions>
                      </v-col>
                    </v-row>
                  </view-container>
                </v-stepper-content>
              </v-card>
            </v-col>
          </v-row>
        </view-container>
      </v-stepper-items>
    </v-stepper>
  </view-container>
</template>
<script>
import ds from "@/datastore";
import { TaxSystems } from "@/datastore/enums";
export default {
  name: "ClientAdd",
  data() {
    return {
      config: {
        addTestDevice: false,
        device: "ams",
        devicePass: "",
        ip: "",
        login: "",
        nonDefaultAccess: false,
        password: "",
        port: ""
      },
      data: {},
      deviceTypes: [
        { id: 0, name: "серверная касса Облако-1Ф", value: "ams" },
        { id: 1, name: "тестовая касса", value: "mock" }
      ],
      isClientExist: false,
      result: {},
      step: 0,
      taxSystems: TaxSystems,
      wrongIpMessage: "",
      wrongLoginMessage: ""
    };
  },
  computed: {
    addr() {
      const port = this.config.port ? this.config.port : "49152";
      return this.config.ip + ":" + port;
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    async getInfo() {
      this.wrongIpMessage = "";
      this.data = {};
      if (!this.validateIpAddress(this.config.ip)) {
        this.wrongIpMessage = "Неверный формат IP-адреса";
        return;
      }
      if (this.config.device == "ams") {
        let r = await ds.getMapper("client").getClientInfo(null, {
          data: {
            addr: this.addr,
            devicePass: this.config.devicePass,
            login: this.config.login,
            pass: this.config.password
          }
        });
        if (r.data.status == 0) {
          this.wrongIpMessage = "Касса незарегистрирована";
          return;
        }
        if (r.data.status == 2) {
          this.wrongIpMessage = "Касса недоступна";
          return;
        }
        this.data.taxSystem = r.data.taxSystem ? r.data.taxSystem : 0;
        this.data.inn = r.data.inn;
        this.data.name = r.data.name;
        this.data.timezone = r.data.timezone;
      }
      this.step = 2;
    },
    async createComplex() {
      this.isClientExist = false;
      this.wrongLoginMessage = "";
      if (!/.+@.+\..+/.test(this.data.login)) {
        this.wrongLoginMessage = "Логин должен быть e-mail адресом";
        return;
      }
      let r = await ds.getMapper("client").createComplex(null, {
        data: {
          name: this.data.name,
          description: this.data.desc,
          max_cashiers: this.data.maxCashiers,
          login: this.data.login,
          inn: this.data.inn,
          tax_system: this.data.taxSystem,
          timezone: this.data.timezone,
          ip: this.addr,
          driver: this.config.device,
          ams_device_pass: this.config.devicePass,
          ams_login: this.config.login,
          ams_pass: this.config.password
        }
      });
      if (r.data.exist) {
        this.isClientExist = true;
        return;
      }
      if (r.data.errors) {
        this.$store.commit(
          "notifications/error",
          "При создании клиента произошла ошибка. Возможно, на сервере проводятся технические работы"
        );
        return;
      }
      this.result.group = r.data.groupId;
      this.result.key = r.data.groupKey;
      this.result.password = r.data.password;
      this.$store.commit(
        "notifications/success",
        "Новый клиент создан и привязан к кассе"
      );
      this.step = 3;
    },
    validate(step) {
      if (step == 1) {
        return this.config.device == "mock" || this.config.ip != "";
      }
      if (step == 2) {
        return (
          this.config.device == "ams" &&
          this.data.name &&
          this.data.inn &&
          this.data.timezone &&
          this.data.desc &&
          this.data.login
        );
      }
      return false;
    },
    validateIpAddress(ipaddress) {
      return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
        ipaddress
      );
    }
  }
};
</script>
